import React, { useState } from 'react'
import { Route, Switch } from 'react-router-dom'
import { Container, Breadcrumb, ListNav } from '../../components'
import { useInternationalization } from '../../features/i18n'
import { useViewport } from '../../utils'
import { DashboardBlogForm } from '../dashboard-blog-form'
import { FormVisibility, PageHeaderDesktop } from './components'
import { PageContent } from './components/page-content.v1'

const Form = ({isEdit, ...props}) => {
  const { translate } = useInternationalization()
  const tabs = [
    'Field Blog',
    translate('DASHBOARD', 'visibility_settings')
  ]
  const [activeTab, setActiveTab] = useState(tabs[0])
  const { isDesktop } = useViewport()

  const routes = [
    {
      name: translate('NAVIGATION', 'dashboard'),
      route: '/dashboard'
    },
    {
      name: translate('BLOG', 'our'),
      route: '/dashboard/blog'
    },
  ]

  return (
    isDesktop ? <>
      <div>
        <Breadcrumb routes={routes}/>
        <h1 className="text-4xl font-bold font-primary">
          { isEdit ? 'Edit Blog' : translate('BLOG', 'create') }
        </h1>
        <hr className="mt-5 mb-8"/>
        {
          isEdit &&
          <ListNav tabs={tabs} activeTab={activeTab} onChange={(e) => setActiveTab(e)}/>
        }
      </div>
      {
        activeTab === tabs[0] &&
        <DashboardBlogForm {...props}/>
      }
      {
        activeTab === tabs[1] &&
        <FormVisibility />
      }
    </> : <>
      {
        isEdit &&
        <ListNav tabs={tabs} activeTab={activeTab} onChange={(e) => setActiveTab(e)}/>
      }
      <Container>
        {
          activeTab === tabs[0] &&
          <DashboardBlogForm {...props}/>
        }
        {
          activeTab === tabs[1] &&
          <FormVisibility />
        }
      </Container>
    </>
  )
}

const DashboardBlog = () => {
  const { isDesktop } = useViewport()

  return (
    <Switch>
      <Route
        path="/dashboard/blog/update/:id"
        render={(props) => <Form {...props} isEdit/>}
      />
      <Route
        path="/dashboard/blog/create"
        render={(props) => <Form {...props}/>}
      />
      <Route path="/dashboard/blog">
        { isDesktop && <PageHeaderDesktop /> }
        { isDesktop && <PageContent /> }
        { !isDesktop &&
          <Container className="py-5">
            <PageContent />
          </Container>
        }
      </Route>
    </Switch>
  )
}

export { DashboardBlog }
